"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var spaui_1 = require("@tencent/spaui");
var classnames_1 = __importDefault(require("classnames"));
var spaui_utils_1 = require("@tencent/spaui-utils");
var info_1 = __importDefault(require("./info"));
var CheckTabsComponent = function CheckTabsComponent(props) {
  var value = props.value,
    data = props.data,
    children = props.children,
    navClassName = props.navClassName,
    _a = props.unmountInactivePanel,
    unmountInactivePanel = _a === void 0 ? true : _a,
    // 卸载非激活的面板
    _b = props.onChange,
    // 卸载非激活的面板
    onChange = _b === void 0 ? void 0 : _b,
    _c = props.showRadioGroup,
    showRadioGroup = _c === void 0 ? true : _c;
  var hasActive = false;
  var childrenWithProps = react_1["default"].Children.map(children, function (child) {
    var item = child;
    var active = value === item.props.name;
    if (active) {
      hasActive = true;
    }
    if (!unmountInactivePanel) {
      return react_1["default"].cloneElement(item, {
        className: (0, classnames_1["default"])(item.props.className, {
          active: active
        })
      });
    }
    return active ? react_1["default"].cloneElement(item, {
      className: (0, classnames_1["default"])(item.props.className, {
        active: active
      })
    }) : null;
  });
  return react_1["default"].createElement("div", __assign({}, (0, spaui_utils_1.globalProps)(props, {
    className: (0, classnames_1["default"])('odc-check-tabs', {
      'has-active': hasActive
    }),
    supportAllEvents: true
  }, CheckTabsComponent)), showRadioGroup ? react_1["default"].createElement(spaui_1.RadioGroup, {
    data: data,
    onChange: onChange,
    value: value,
    className: (0, classnames_1["default"])('odc-text-normal', navClassName)
  }) : null, childrenWithProps);
};
(0, spaui_utils_1.setComponentMark)(CheckTabsComponent, info_1["default"]);
exports["default"] = CheckTabsComponent;